/* @flow */

import * as React from 'react';

import {Button} from 'shells/button';
import {Dialog} from 'shells/dialog';

import type {ButtonVariant, ButtonSize} from 'shells/button/types';

type Props = {
    onConfirm: () => void,
    question: string,
    buttonText?: string, // defaults to 'Remove'
    primaryText?: string, // defaults to 'Yes, remove'
    secondaryText?: string, // defaults to 'No, don’t remove'
    buttonVariant?: ButtonVariant, // defaults to 'secondary'
    buttonSize?: ButtonSize, // defaults to 'normal'
};

export function TextButtonWithConfirmation(props: Props) {
    const {
        onConfirm,
        question,
        buttonText = 'Remove',
        primaryText = 'Yes, remove',
        secondaryText = 'No, don’t remove',
        buttonVariant = 'secondary',
        buttonSize = 'normal',
    } = props;
    const [isConfirmingRemove, setIsConfirmingRemove] = React.useState<boolean>(false);
    const removeRef = React.useRef();

    return (
        <>
            <Button
                getButtonRef={removeRef}
                onClick={() => setIsConfirmingRemove(true)}
                variant={buttonVariant}
                size={buttonSize}
            >
                {buttonText}
            </Button>
            {isConfirmingRemove ? (
                <Dialog
                    anchor={removeRef.current}
                    location='top'
                    question={question}
                    primaryText={primaryText}
                    secondaryText={secondaryText}
                    onPrimary={onConfirm}
                    onSecondary={() => {
                        setIsConfirmingRemove(false);
                    }}
                    isWarning={true}
                />
            ) : undefined}
        </>
    );
}
